import React, { Component } from 'react';
import { Container, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';

import './NavMenu.css';

export class RoleDropdown extends Component {
  constructor (props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      role: this.props.role,
    };
  }

  toggleDropDown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  selectedRole = (e) => {
    console.log(e.target.key);
    //this.props.assignRole(e.target.key);
  }

  

  render () {
    const roles = JSON.parse(sessionStorage.getItem("role"));
    
    let dropdownItems = null;
    
    if(roles !== null && !roles.includes("Superuser") && roles.length > 1){
        dropdownItems = roles.map(element => {
            return(
                <DropdownItem key={element} onClick={() => this.props.setRole(element)}>
                    <NavItem >
                        <NavLink tag={Link} to="" className="text-dark">
                            {element}
                        </NavLink>
                    </NavItem>
                </DropdownItem>
            )
        });
    }
    else if(roles !== null && roles.includes("Superuser")) {
        const tempArray = ['Agenti', 'Amministrazione', 'Controller'];

        dropdownItems = tempArray.map(element => {
            return(
                <DropdownItem key={element} style={{paddingLeft: "5px", paddingRight: "5px"}} onClick={() => this.props.setRole(element)}>
                    <NavItem >
                        <NavLink tag={Link} to="" className="text-dark">
                            {element}
                        </NavLink>
                    </NavItem>
                </DropdownItem>
            )
        });
    }
    
    
    return ( 
        <div>
            {(localStorage.getItem("role") !== null && (localStorage.getItem("role")[0] !== "Superuser" || localStorage.getItem("role").length > 1)) || (sessionStorage.getItem("role") !== null && (sessionStorage.getItem("role")[0] !== "Superuser" || sessionStorage.getItem("role").length > 1)) 
                ? <Dropdown direction="left" nav isOpen={this.state.dropdownOpen} toggle={this.toggleDropDown}>
                    <DropdownToggle style={{color: 'white'}} nav caret>
                        {this.props.role}
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem header>{this.props.header}</DropdownItem>
                        <Container>
                            {dropdownItems}
                        </Container>
                    </DropdownMenu>
                </Dropdown>
            : null}
        </div>
        
           
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/RoleDropdown.js